import type { BlockConfigExport } from '@tmh-website/components/blocks.types';

export const onboardingFlowMercedesConfig: BlockConfigExport = {
  // If the block should decrease padding to the previous block if they have some background color
  consecutiveBlockPadding: true,
  // Which fields should be populated by Strapi
  populateOptions: [
    'customerInfoE14LawCheckboxEntries',
    'tariffDetailsCardMeterPopupImage',
    'tariffDetailsElectricityTariffArticlesEntries',
    'tariffDetailsElectricityTariffArticlesEntries.link',
    'tariffDetailsElectricityTariffArticlesEntries.link.image',
    'tariffDetailsMoreDetailsHeaderImage',
    'orderReviewLegalLinkEntries',
    'orderReviewCheckboxes',
  ],
};

/**
 * Represents the URL query parameter used to pass correlation ID in a request.
 */
export const ENTRY_CORRELATION_ID_URL_QUERY_PARAM: string = 'entry';
